import { render, staticRenderFns } from "./ContractInteraction.vue?vue&type=template&id=35902110&scoped=true&"
import script from "./ContractInteraction.vue?vue&type=script&lang=js&"
export * from "./ContractInteraction.vue?vue&type=script&lang=js&"
import style0 from "./ContractInteraction.vue?vue&type=style&index=0&id=35902110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35902110",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VContainer,VIcon,VRow,VSkeletonLoader})
